import {useEffect, useState} from 'react';

export function useWindowInnerHeight() {
  const [innerHeight, setInnerHeight] = useState(0);
  useEffect(() => {
    const windowResizeListener = () => {
      setInnerHeight(window.innerHeight);
    };
    windowResizeListener();
    window.addEventListener('resize', windowResizeListener);
    return () => {
      window.removeEventListener('resize', windowResizeListener);
    };
  }, []);
  return innerHeight;
}
